var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKefu4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3D6BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9833 13.8904C16.1504 13.8904 13.4628 15.534 13.4628 15.534C14.9366 14.2191 17.5083 13.4607 17.5083 13.4607L17.2655 13.218C14.8485 13.2609 12.6614 14.9346 12.6614 14.9346C10.2036 20.0672 10.3604 24.4994 10.3604 24.4994C12.3628 27.0861 15.3362 26.9014 15.3362 26.9014L16.3524 25.6145C14.5649 25.2277 13.4348 23.6422 13.4348 23.6422C13.4348 23.6422 16.1225 25.4727 19.9833 25.4727C23.844 25.4727 26.5317 23.6422 26.5317 23.6422C26.5317 23.6422 25.4016 25.2299 23.6141 25.6145L24.6303 26.9014C24.6303 26.9014 27.6038 27.0883 29.6061 24.4994C29.6061 24.4994 29.7629 20.0672 27.303 14.9346C27.303 14.9346 25.1159 13.2609 22.6989 13.218L22.4561 13.4607C22.4561 13.4607 25.0299 14.2191 26.5016 15.534C26.5038 15.534 23.8161 13.8904 19.9833 13.8904ZM17.0249 19.3088C17.9551 19.3088 18.7114 20.123 18.6985 21.1242C18.6985 22.1104 17.9551 22.9396 17.0249 22.9396C16.1096 22.9396 15.3663 22.1104 15.3663 21.1242C15.3663 20.123 16.0946 19.3088 17.0249 19.3088ZM22.9868 19.3088C23.917 19.3088 24.6604 20.123 24.6604 21.1242C24.6604 22.1104 23.917 22.9396 22.9868 22.9396C22.0715 22.9396 21.3282 22.1104 21.3282 21.1242C21.3282 20.123 22.0565 19.3088 22.9868 19.3088Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKefu4);
export default __webpack_public_path__ + "static/media/kefu4.12ddf788453d60ee6069161767e0af91.svg";
export { ForwardRef as ReactComponent };